import { analytics } from '@app/app/analytics';
import { PlatformName } from '@app/app/analytics/types';
import { Slide } from '@app/widgets/canvas/types';
import { useFromModeDetection } from '@app/widgets/canvas/hooks/useFromModeDetection';

import { isSuccessfulCompose } from './utils';

const allowedFlows = ['prompt', 'pdf', 'docx', 'pptx', 'blank', 'templates'] as const;
type AllowedFlow = (typeof allowedFlows)[number];
function isAllowedFlow(flow: string): flow is AllowedFlow {
  return allowedFlows.includes(flow as AllowedFlow);
}

// Функция аналитики без хуков для использования в сторе
export const checkSlidesAnalytics = (
  slides: Slide[],
  workspaceId: string,
  flow: string,
  alreadyDone?: boolean,
  initialSlides?: number[],
  alreadyDoneGenerationDone?: boolean,
): boolean | 'done' => {
  if (!isAllowedFlow(flow)) {
    console.warn('[Analytics] Flow not allowed:', flow);
    return false;
  }
  // generation_first_slide_done: пушим, если хотя бы один слайд успешно сгенерен и ещё не пушили
  // ВАЖНО: проверяем ПЕРЕД generation_done, чтобы не пропустить событие
  const hasSuccessfulCompose = slides.some(
    (slide) => slide.stages && slide.stages.some(isSuccessfulCompose),
  );
  const shouldSendFirstSlideDone = !alreadyDone && slides.length > 0 && hasSuccessfulCompose;

  if (shouldSendFirstSlideDone) {
    analytics.emitEvent('generation_first_slide_done', {
      [PlatformName.GTM]: {
        event: 'generation_first_slide_done',
        processed_file_id: workspaceId,
        flow,
      },
    });
    return true;
  }
  // generation_done: пушим, когда все initialSlides слайды успешно сгенерены и ещё не пушили generation_done
  if (
    initialSlides &&
    initialSlides.length > 0 &&
    initialSlides.every(
      (slideId) =>
        slides.find((slide) => slide.id === slideId)?.stages &&
        slides.find((slide) => slide.id === slideId)?.stages.some(isSuccessfulCompose),
    ) &&
    flow !== 'blank' &&
    !alreadyDoneGenerationDone
  ) {
    analytics.emitEvent('generation_done', {
      [PlatformName.GTM]: {
        event: 'generation_done',
        processed_file_id: workspaceId,
        flow,
      },
    });
    return 'done';
  }
  return false;
};

export const useSlidesGenerationAnalytics = (workspaceId: string) => {
  const { flow } = useFromModeDetection();
  const checkForSlidesAnalytics = (slides: Slide[]) => {
    checkSlidesAnalytics(slides, workspaceId, flow);
  };
  return { checkForSlidesAnalytics };
};
